export default {
  occurrenceUnit: 'Wiederholung | Wiederholungen',
};
